import React, { useState, useCallback, useRef, useEffect } from 'react';
import SqlexecTable from './SqlexecTable';
import { useSisConfig } from '../../contexts/SisConfigUi';

const SqlexecSplitPanel = ({
  componentForm,
  detailForm,
  splitKey,
  autoSelectFirst = true,
  masterFlex = 60,
  detailFlex = 40,
  selectedId: externalSelectedId = null,
  selectedRow: externalSelectedRow = null,
  detailOnly = false,
}) => {

  const { panel_ui } = useSisConfig();
  const divider = panel_ui?.splitPanel?.divider || {};

  // ==========================================
  // ESTADO INTERNO
  // SOLO SI NO VIENE EXTERNO
  // ==========================================
  const [internalSelectedRow, setInternalSelectedRow] = useState(null);
  const [internalSelectedId, setInternalSelectedId] = useState(null);

  const autoSelectedRef = useRef(false);

  // ==========================================
  // SELECCIÓN FINAL
  // PRIORIDAD:
  // 1. EXTERNA
  // 2. INTERNA
  // ==========================================
  const selectedId =
    externalSelectedId ?? internalSelectedId;

  const selectedRow =
    externalSelectedRow ?? internalSelectedRow;

  // ==========================================
  // AUTO SELECT FIRST
  // ==========================================
  const handleMasterDataReady = useCallback((data) => {

    // YA HAY SELECCIÓN EXTERNA
    if (externalSelectedId !== null) return;

    // DESACTIVADO
    if (!autoSelectFirst) return;

    // YA SE AUTOSELECCIONÓ
    if (autoSelectedRef.current) return;

    // SIN DATOS
    if (!data?.length) return;

    autoSelectedRef.current = true;

    const first = data[0];
    const firstId = first[splitKey];

    setInternalSelectedRow(first);
    setInternalSelectedId(firstId);

  }, [autoSelectFirst, splitKey, externalSelectedId]);

  // ==========================================
  // CLICK ROW
  // ==========================================
  const handleRowSelect = useCallback((row) => {

    if (!row) return;

    const newId = row[splitKey];

    // EVITA RENDER SI ES EL MISMO
    if (newId === selectedId) return;

    setInternalSelectedRow(row);
    setInternalSelectedId(newId);

  }, [splitKey, selectedId]);

  return (
    <div style={{
      display:       panel_ui?.splitPanel?.container?.display       || 'flex',
      flexDirection: panel_ui?.splitPanel?.container?.flexDirection || 'column',
      flex:          panel_ui?.splitPanel?.container?.flex          || 1,
      minHeight:     panel_ui?.splitPanel?.container?.minHeight     || 0,
      overflow:      panel_ui?.splitPanel?.container?.overflow      || 'hidden'
    }}>

      {/* MASTER */}
      {!detailOnly && (
        <div style={{
          flex:          masterFlex,
          minHeight:     panel_ui?.splitPanel?.master?.minHeight     || 0,
          display:       panel_ui?.splitPanel?.master?.display       || 'flex',
          flexDirection: panel_ui?.splitPanel?.master?.flexDirection || 'column',
          overflow:      panel_ui?.splitPanel?.master?.overflow      || 'hidden'
        }}>
          <SqlexecTable
            componentForm={componentForm}
            parentKey={null}
            parentValue={null}
            parentRow={null}
            onRowSelect={handleRowSelect}
            onDataReady={handleMasterDataReady}
            selectedExternalId={selectedId}
          />
        </div>
      )}

      {/* DIVIDER */}
      {!detailOnly && (
        <div style={{
          height:          divider.height,
          backgroundColor: divider.backgroundColor,
          flexShrink:      0,
          borderTop:       divider.borderTop,
          borderBottom:    divider.borderBottom
        }} />
      )}

      {/* DETAIL */}
      <div style={{
        flex:          detailOnly ? 1 : detailFlex,
        minHeight:     panel_ui?.splitPanel?.detail?.minHeight     || 0,
        display:       panel_ui?.splitPanel?.detail?.display       || 'flex',
        flexDirection: panel_ui?.splitPanel?.detail?.flexDirection || 'column',
        overflow:      panel_ui?.splitPanel?.detail?.overflow      || 'hidden'
      }}>
        <SqlexecTable
          componentForm={detailForm}
          parentKey={splitKey}

          // IMPORTANTE:
          // SOLO EL ID DEBE DISPARAR REFRESH
          parentValue={selectedId}

          // OPCIONAL:
          // SI PUEDES ELIMINAR ESTO, MEJOR
          parentRow={selectedRow}

          reactiveParentRefresh={true}
          onRowSelect={null}
          emptyState="no-filter"
          showSearch={false}
          showFooter={false}
          compactToolbar={true}
        />
      </div>

    </div>
  );
};

export default SqlexecSplitPanel;